import { type DocumentDetailsVersion, type IdAndTitle } from "~/api/types";
import InviteReadersModal from "~/organisms/InviteReadersModal";
import { ReadersOverview } from "~/organisms/ReadersOverview";
import { canInviteReaders } from "~/helpers/documentPermissions";

interface Props {
  documentVersion: DocumentDetailsVersion;
  category: IdAndTitle;
}

export const ReadersOverviewTab = ({ documentVersion, category }: Props) => {
  const isInviteAllowed = canInviteReaders(documentVersion);

  return (
    <div className="grid gap-4">
      {isInviteAllowed && (
        <InviteReadersModal
          documentVersionId={documentVersion.id}
          category={category}
        />
      )}

      <ReadersOverview
        documentVersionId={documentVersion.id}
        isRemoveAllowed={isInviteAllowed}
      />
    </div>
  );
};
